import { render, staticRenderFns } from "./push_tag.vue?vue&type=template&id=054d64d1&scoped=true&"
import script from "./push_tag.vue?vue&type=script&lang=js&"
export * from "./push_tag.vue?vue&type=script&lang=js&"
import style0 from "./push_tag.vue?vue&type=style&index=0&id=054d64d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d64d1",
  null
  
)

export default component.exports